<template>
  <div>
      <div style="background-image:url(https://file.lgbfss.com/www/official/images/login.jpg);background-size:100% 100%; height:1000px;">
        <div class="content">
          <div class="container">
            <div class="login-box">
              <div><img src="https://file.lgbfss.com/www/official/images/logo.png" alt="" style="width:200px"/></div>
              <div class="login-form">
                <h5 class="font-color-3">零工创客服务平台</h5>
                <form action="">
                  <div>
                      <img src="https://file.lgbfss.com/www/official/images/user.jpg" alt="">
                    <input type="text" placeholder="用户名/账号/手机号" />
                  </div>
                  <div>
                       <img src="https://file.lgbfss.com/www/official/images/lock.jpg" alt="">
                    <input type="text" placeholder="请输入您的密码" />
                  </div>
                  <button class="login-btn">登录</button>
                </form>
                <div class="row" style="justify-content: space-between;padding: 0 18px;">
                  <div><a href="./register">注册帐号</a></div>
                  <div><a href="./find_pwd">忘记密码</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "login",
 
};
</script>

<style lang="css" scoped>
.login-box{
    display: flex;
    justify-content: space-between;
    padding-top: 125px;
}
.login-box a{
    color: #666666;
}
.login-box a:hover{
    color: #5fccff;
}
.login-form{
    background-color: #fff;
    border-radius: 10px;
    padding: 50px 30px 40px 30px;

}
.login-form form>div{
    margin: 20px 0;
    padding-left: 50px;
    position: relative;
    background-color: #f8f8f8;
}
.login-form form>div>img{
    position: absolute;
    left: 10px;
    top: 10px;
    width: 25px;
    height: 25px;
}
.login-form form>div>input{
    width: 100%;
    height: 45px;
    border: none;
    background-color: #f8f8f8;
    color: #c5c5c5;
    border-radius: 10px;
    font-size: 16px;
}
.login-box h5{
    font-size: 36px;
}
.login-btn{
    width: 100%;
    height: 45px;
    border: none;
    color: #fff;
    background-image: linear-gradient(to right, #5b87e5, #64cdff);
    margin: 20px 0 20px 0;
    border-radius: 45px;
    outline:none;
    cursor: pointer;
}


</style>
